module.exports = __webpack_public_path__ + "static/img/projectService_4.6dde6a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainPage/projectService_4.jpg
// module id = LzsG
// module chunks = 0